import { createStoreon, StoreonModule, StoreonStore } from 'storeon'

import { PERSIST_STATE_KEY } from 'Constants/Store'

import shared from 'Services/Shared'

import uiModule, { Events as UiEvents, State as UiState } from './ui'

type State = UiState
type Events = UiEvents

type Store = StoreonStore<State, Events>

function createStore() {
  // Nothing is persisted anymore. The old store wrote the full /work
  // project list (150-250KB, with content-hashed image paths that went
  // stale across deploys) into this localStorage key and re-parsed it on
  // every page load — clear the leftover blob for returning visitors.
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(PERSIST_STATE_KEY)
  }

  const modules: Array<StoreonModule<State, Events> | false> = [uiModule]

  const store = createStoreon(modules)

  shared.setStore(store)

  return store
}

export function clearStore() {
  return shared.getStore()?.dispatch('clear')
}

export const store = createStore()
export type { Store }
